module.exports = __webpack_public_path__ + "dash_20_app_assets/img/sus.dce8ce89.png";